module.exports = __webpack_public_path__ + "img/process-match.867f4cb8.jpg";